import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import RateFeedbackQuestion from '../../FeedbackRating/RateFeedbackQuestion';
import ThanksForRating from '../../FeedbackRating/ThanksForRating';
import { useTranslation } from '../../useTranslation';
import RatingDialog from './RatingDialog';
import { jsx as ___EmotionJSX } from "@emotion/react";
var Rating = function Rating(_ref) {
  var messageType = _ref.messageType,
    predictionId = _ref.predictionId,
    rated = _ref.rated,
    saveScore = _ref.saveScore,
    setPredictionRated = _ref.setPredictionRated,
    setRated = _ref.setRated,
    uuid = _ref.uuid;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalVisible = _useState2[0],
    setModalVisible = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var submitFeedback = useCallback(function (body) {
    saveScore({
      body: body,
      params: {
        predictionId: predictionId
      }
    });
    setRated(true);
    setPredictionRated(uuid);
  }, [predictionId, saveScore, setPredictionRated, setRated, uuid]);
  var handlePositiveFeedback = useCallback(function () {
    submitFeedback({
      score: 1
    });
  }, [submitFeedback]);
  var handleNegativeFeedback = useCallback(function () {
    setModalVisible(true);
  }, []);
  var handleDialogFeedback = useCallback(function (submittedValue) {
    submitFeedback({
      feedback: submittedValue,
      score: 0
    });
    setModalVisible(false);
  }, [submitFeedback]);
  var onClose = useCallback(function () {
    submitFeedback({
      score: 0
    });
    setModalVisible(false);
  }, [submitFeedback]);
  return ___EmotionJSX("div", {
    className: 'dc-sct-feedback__footer'
  }, rated ? ___EmotionJSX(ThanksForRating, {
    ratedMessage: t('AiAssistantRating.ratedMessage')
  }) : ___EmotionJSX(RateFeedbackQuestion, {
    messageType: messageType,
    onRateNotUseful: handleNegativeFeedback,
    onRateUseful: handlePositiveFeedback,
    question: t('AiAssistantRating.question')
  }), ___EmotionJSX(RatingDialog, {
    isOpen: modalVisible,
    onClose: onClose,
    onSubmit: handleDialogFeedback
  }));
};
export default Rating;